import { NgModule } from '@angular/core';
import {SubscribeComponent} from "./subscribe.component";
import {FormsModule,} from "@angular/forms";

@NgModule({
  declarations: [SubscribeComponent],
  exports: [SubscribeComponent],
  imports: [FormsModule],
  providers: []
})
export class SubscribeModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/subscribe/subscribe.module.ts